<div class="container-fluid">
  <div class="row font-weight-bold mb-2">Menu</div>
  <div class="row">
    <div class="col">{{'EXPANDED_MENU'| translate}}</div>
    <div class="col">
      <div class="form-check p-0 mt-0">
        <div class="toggles p-0 mt-0">
          <label for="expandedMenu">
            <input [checked]="configForm?.get('layout').get('expandedMenu').value === true"
                   [formControl]="configForm?.get('layout').get('expandedMenu')"
                   id="expandedMenu"
                   type="checkbox"
            >
            <span class="lever"></span>
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="row font-weight-bold mb-2">{{'CONFIG.DETAILS' | translate}}</div>
  <div class="row">
    <div class="col">{{'CONFIG.DETAILS.ALL_ACCORDION_OPEN'| translate}}</div>
    <div class="col">
      <div class="form-check p-0 mt-0">
        <div class="toggles p-0 mt-0">
          <label for="accordionsOpen">
            <input [checked]="configForm?.get('layout').get('accordionsOpen').value === true"
                   [formControl]="configForm?.get('layout').get('accordionsOpen')"
                   id="accordionsOpen"
                   type="checkbox"
            >
            <span class="lever"></span>
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="row font-weight-bold mb-2">{{'REQUEST_REVIEW' | translate}}</div>
  <div class="row">
    <div class="col">{{'MINIMIZED_REVIEW'| translate}}</div>
    <div class="col">
      <div class="form-check p-0 mt-0">
        <div class="toggles p-0 mt-0">
          <label for="minimizedReview">
            <input [checked]="configForm?.get('layout').get('minimizedReview').value === true"
                   [formControl]="configForm?.get('layout').get('minimizedReview')"
                   id="minimizedReview"
                   type="checkbox"
            >
            <span class="lever"></span>
          </label>
        </div>
      </div>
    </div>
  </div>

</div>
